import { ChangeDetectionStrategy, Component } from '@angular/core';
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';
import { makeTooltipProvider } from '../../../../../../cross-team-shared/tooltips/tooltip-utils';
import { EventTrackingService } from '../../../../../../shared/event-tracking/event-tracking.service';

@Component({
  selector: 'h3-tag-option-list',
  templateUrl: './tag-option-list.component.html',
  styleUrls: ['./tag-option-list.component.scss'],
  providers: [makeTooltipProvider({ position: 'left' })],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TagOptionListComponent {
  collapsed = true;
  faAngleDoubleRight = faAngleDoubleRight;

  constructor(private eventTrackingService: EventTrackingService) {}

  toggleExpanded() {
    this.collapsed = !this.collapsed;
    this.eventTrackingService.track({
      id: 'toggle_tag_option_list',
      bucket: 'tag_selection',
      expanded: !this.collapsed,
    });
  }
}
